/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Irrigation_Schedule_SavedInputs */

const vi_irrigation_schedule_saved = /** @type {(inputs: Irrigation_Schedule_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã lưu lịch tưới ${i?.name}`)
};

/**

* @param {Irrigation_Schedule_SavedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_saved = /** @type {((inputs: Irrigation_Schedule_SavedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_SavedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_saved(inputs)
});